// LanguageDropdown.js
import React, { useState, useEffect } from 'react';
import DropdownWithMultiLingual from '../dropdown-multilingual';
// import DropdownWithMultiLingual from './DropdownWithMultiLingual';

export const languageOptions = ['English', 'Hindi', 'Tamil', 'Telugu', 'Kannada', 'Malayalam','Urdu', 'Gujarati', 'Marathi', 'Punjabi', 'Bengali', 'Odia', 'Assamese', 'Nepali', 'Konkani', 'Sindhi', 'Kashmiri', 'Sanskrit', 'Dogri', 'Maithili', 'Santali','English (US)', 'English (UK)', 'Spanish (Spain)', 'French (France)', 'German (Germany)', 'Italian (Italy)', 'Chinese (Simplified)', 'Arabic (Standard)'];

export const languageCodeMap = {
  English: "en-US",
  Hindi: "hi-IN",
  Bengali: "bn-IN",
  Tamil: "ta-IN",
  Telugu: "te-IN",
  Kannada: "kn-IN",
  Malayalam: "ml-IN",
  Gujarati: "gu-IN",
  Marathi: "mr-IN",
  Punjabi: "pa-IN",
  Urdu: "ur-IN",
  Assamese: "as-IN",
  Odia: "or-IN",
  Nepali: "ne-IN",
  Konkani: "kok-IN",
  Sindhi: "sd-IN",
  Kashmiri: "ks-IN",
  Sanskrit: "sa-IN",
  Dogri: "doi-IN",
  Maithili: "mai-IN",
  Santali: "sat-IN",
  "English (US)": "en-US",
  "English (UK)": "en-GB",
  "Spanish (Spain)": "es-ES",
  "French (France)": "fr-FR",
  "German (Germany)": "de-DE",
  "Italian (Italy)": "it-IT",
  "Chinese (Simplified)": "zh-CN",
  "Arabic (Standard)": "ar-SA",
};

// const LanguageDropdown = ({ 
//   onLanguageChange, 
//   defaultLanguage = "English",
//   placeholder,
//   menuList = { pos: 'relative', right: '75px' },
//   ...props 
// }) => {
//   const [selectedLanguage, setSelectedLanguage] = useState(defaultLanguage);

//   const handleChangeLanguage = (e) => {
//     const selectedLanguage = e.value;
//     setSelectedLanguage(selectedLanguage);
//     const languageCode = languageCodeMap[selectedLanguage] || "en-US";
    
//     if (onLanguageChange) {
//       onLanguageChange({
//         language: selectedLanguage,
//         code: languageCode
//       });
//     }
//   };

//   return (
//     <DropdownWithMultiLingual 
//       menuList={menuList}
//       placeholder={placeholder || selectedLanguage}
//       onClick={handleChangeLanguage}
//       options={languageOptions.map(value => ({ value }))}
//       {...props}
//     />
//   );
// };

// export default LanguageDropdown;